import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-setting',
  standalone: false,
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css'
})
export class SettingComponent {
  userRole: string;
  constructor(private auth: AuthService) {
    this.userRole = this.auth.getRoles();
  }
}
